import React, { type FunctionComponent } from 'react'
import { LoadingBox } from 'ic-snacks'
import { Box } from 'legacy/dash-blocks/box/Box'
import { EmptyViewReload } from 'legacy/dash-components/empty-view-reload/EmptyViewReload'
import { type PerformanceMetricsBehaviour } from 'legacy/sections/analytics/components/performance-metrics/utils/performanceMetrics.hooks'
import DynamicContainer from 'legacy/components/DataViz/DynamicContainer'

interface Props extends PerformanceMetricsBehaviour {}

export const PerformanceMetricsBody: FunctionComponent<Props> = ({
  error,
  loading,
  performanceMetricsData,
}) => {
  if (error) {
    return (
      <EmptyViewReload
        titleId="common.error.title"
        bodyId="common.error"
        testId="performance-metrics-body-error"
      />
    )
  }

  if (loading) {
    return (
      <Box fillWidth fillHeight padding="small" testId="performance-metrics-body-loading">
        <LoadingBox shape="square" background="light" style={{ width: '100%' }} size={500} />
      </Box>
    )
  }

  const dynamicAnalyticsContent = performanceMetricsData.map((props, i) => (
    // This dynamic-container pattern is a legacy pattern
    // We should eventually update it to use a more declarative pattern
    // eslint-disable-next-line react/no-array-index-key
    <DynamicContainer key={i} {...props} />
  ))

  return (
    <Box padding="small" testId="performance-metrics-body-dynamic-content">
      {dynamicAnalyticsContent}
    </Box>
  )
}
